import { render, staticRenderFns } from "./PlateLegend.vue?vue&type=template&id=95bf4b50&scoped=true&"
import script from "./PlateLegend.vue?vue&type=script&lang=js&"
export * from "./PlateLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bf4b50",
  null
  
)

export default component.exports